'use strict'

// General is tab 0 on every view editor. Opening the editor starts there.
// Confirming "add column to view" while the editor is already open should
// return to the list that field was added to.

function fieldListTabIndex (editor) {

  if (!editor) return 0

  if (editor.cards) {

    // A map or calendar inserts Location or Calendar before Fields.
    return (editor.isMap || editor.isCalendar) ? 2 : 1
  }

  if (editor.table || editor.form) return 1

  return 0
}

function viewEditorTabAfterColumnDialog (editorAlreadyOpen, editor) {

  if (!editorAlreadyOpen) return 0

  return fieldListTabIndex(editor)
}

module.exports = {
  fieldListTabIndex,
  viewEditorTabAfterColumnDialog
}
